import { once } from 'lodash-es';

export const isEpiserverFactory = once((document: Document) => {
    return document.querySelector('html')?.dataset.plc != null;
});
